import React, { useEffect, useState } from 'react';
import PageWrapper from '../layouts/Index';
import PageTitle from '../components/PageTitle';
import {getAllDevices, getDeviceByCreditLimit, setSelectedDevice, updateAllDevicesPagination, updateAllDevicesSearch,} from "../redux/features/oxygen/oxygenRetailSlice";
import { useDispatch, useSelector } from 'react-redux';
import Pagination from '../components/Pagination';
import OxygenDeviceCard from '../components/OxygenDeviceCard';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { checkDeviceExistance } from '../services/oxygenRetailServices';
import { setLoader } from '../redux/features/modalAlert.js/modalSlice';
import { setMySelectedDevice } from '../redux/features/users/UserSlice';

const OxygenAllDevices = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [searchValue, setSearchValue] = useState('');
    const devices = useSelector((state) => state.oxygenRetail) || [];
    const precustomer =  useSelector((state) => state?.precustomer?.precustomerData.precustomer);
    const amount  =  searchParams.get("amount");;

   useEffect(() => {
        const hasAmount = !!amount && !isNaN(amount) && Number(amount) > 0;

        const handler = setTimeout(() => {
            if (hasAmount) {
                dispatch(getDeviceByCreditLimit(amount));
            } else {
                dispatch(getAllDevices());
            }
        }, 500); 

        return () => clearTimeout(handler);
    }, [dispatch, amount, devices?.devicesParams]);


     const handlePagination = (page) => {
        dispatch(updateAllDevicesPagination(page));
    };

    const paginationData = {
        totalPages: devices?.allDevices?.meta?.totalPages,
        currentPage: devices?.allDevices?.meta?.currentPage,
        handlePagination
    }

    const handleSearchDevice  = async() => {
        const payload = searchValue;
        dispatch(updateAllDevicesSearch(payload));
    }

    const handleSelectDevice = async(device) => {
        let res;
        dispatch(setLoader({ status: true }));
        dispatch(setSelectedDevice(device));
        dispatch(setMySelectedDevice(device));
        localStorage.setItem("device_type_id", JSON.stringify(device?.id));
        localStorage.setItem("device_amount", JSON.stringify(device?.fullPriceNaira));
        const payload = {
            phoneNumber:String(precustomer?.msisdn)
        }
    
        res = await checkDeviceExistance(payload);
        console.log("res:", res);

        if(res?.status === true) {
            dispatch(setLoader({ status: false }));
            navigate(`/oxygen-device-bundles`);
        }else{
            dispatch(setLoader({ status: false }));
            navigate('/proposed-devices-bundle');
        }
    }


  return (
    <PageWrapper>
        <PageTitle title={`All Devices`} />
        {
        devices?.loading ? (
            <p className='text-center'>Fetching devices...</p>
        ): (
            <>
            <div class="mb-5 mt-7 d-flex justify-content-end ">
                <div class="input-group customInputWidth ">
                    <input 
                        type="search"
                        value={searchValue} 
                        className="form-control bg-light"
                        placeholder="Search devices"
                        onChange={(e)=> setSearchValue(e.target.value)}
                    />
                    <span class="input-group-text" id="button-addon1" style={{borderRadius: "0 5px 5px 0", boxShadow: "0 4px 8px rgba(128, 128, 128, 0.4)", cursor: "pointer", fontWeight:"600"}}
                        onClick={handleSearchDevice}
                    >Search</span>
                </div>
            </div>
            {
                devices?.allDevices?.data?.length === 0 ? (
                    <h4 className='text-center mt-8'>No device found</h4>
                ):(
                <div className="row my-8">
                    {devices?.allDevices?.data?.map((device) => (
                        <div className="col-12 col-md-6 col-lg-4 col-xl-3 mb-4" key={device?.id}> 
                            <OxygenDeviceCard device={device} onClick={() => handleSelectDevice(device)} />
                        </div>
                    ))}
                </div>
                )
            }
            <Pagination {...paginationData} />
            </>
        )
        }
    </PageWrapper>
  )
}

export default OxygenAllDevices;